import { BaseService } from './base.service'
import { Uris } from '../common/constants'
import { IServiceBookSearchParams } from '../store/service-book/service-book-state.store';

export interface IServiceBookService {
  getServiceBooks: (params: IServiceBookSearchParams) => Promise<any>;
  getServiceBookById: (id:string) => Promise<any>;
  getApartmentTypes: () => Promise<any>;
  associateServiceBook: (id:string,data:any) => Promise<any>;
  transferServiceBook: (id:string,params:{owner_id:number}) => Promise<any>;
  getServiceBookProduct: () => Promise<any>;


}

export class ServiceBookService extends BaseService implements IServiceBookService {

  getServiceBooks (params: IServiceBookSearchParams): Promise<any> {
    return super.get(Uris.ServiceBook, params)
  }

  getServiceBookById(id:string): Promise<any> {
    return super.get(Uris.ServiceBookById.replace(':id', id))
  }

  getApartmentTypes(): Promise<any> {
    return super.get(Uris.ApartmentTypes)
  }

  associateServiceBook(id:string,data:any): Promise<any> {
    return super.patch(Uris.ServiceBookById.replace(':id', id), data)
  }

  transferServiceBook(id:string,params:{owner_id:number}) : Promise<any>{
    return super.post(Uris.TransferServiceBook.replace(':id', id), params)
  }

  getServiceBookProduct()
  {
    return super.get(Uris.ServiceBookProduct)
  }

}



// WEBPACK FOOTER //
// ./src/services/serviceBook.service.ts